<div class="versiones-panel">

  <!-- HEADER -->
  <div class="panel-header">
    <div class="panel-title">
      <mat-icon>history</mat-icon>
      <span>VERSIONES</span>
    </div>

    <div class="panel-actions" >
      <button
      [disabled]="!currentEscritoId"
        mat-icon-button
        class="action-btn"
        (click)="onCreateVersion()"
        matTooltip="Crear Nueva Versión">
        <mat-icon>add</mat-icon>
      </button>

      <button
        mat-icon-button
        [disabled]="!currentEscritoId"
        class="action-btn"
        (click)="onCleanupOldVersions()"
        matTooltip="Limpiar Versiones Antiguas">
        <mat-icon>delete_sweep</mat-icon>
      </button>

        <button
        mat-icon-button
        class="action-btn"
        matTooltip="Actualizar">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>

  <!-- NO ESCRITO SELECTED -->
  <div *ngIf="!currentEscritoId" class="no-escrito-state">
    <mat-icon class="no-escrito-icon">edit_note</mat-icon>
    <p>Selecciona un escrito para ver sus versiones</p>
    <small>Las versiones aparecerán aquí cuando tengas un escrito abierto</small>
  </div>

  <!-- LOADING -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="24"></mat-spinner>
    <span>Cargando versiones...</span>
  </div>

  <!-- VERSIONES LIST -->
  <div class="versiones-container" *ngIf="!isLoading && currentEscritoId">

    <div
      *ngFor="let version of versiones; let i = index"
      class="version-item"
      [class.selected]="selectedVersion?.id === version.id"
      [class.latest]="isLatestVersion(version)"
      (click)="onVersionClick(version)">

      <div class="version-header">
        <div class="version-info">
          <div class="version-number">
            <mat-icon class="version-icon">{{isLatestVersion(version) ? 'fiber_new' : 'history'}}</mat-icon>
            <span class="version-text">Versión {{ version.numeroVersion }}</span>
            <mat-chip *ngIf="isLatestVersion(version)" class="latest-chip">Actual</mat-chip>
          </div>
          <div class="version-date">{{ formatDate(version.fechaCreacion) }}</div>
        </div>

        <button
          mat-icon-button
          class="version-menu"
          [matMenuTriggerFor]="versionMenu"
          (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #versionMenu="matMenu">
          <button mat-menu-item (click)="onCompareWithCurrent(version)">
            <mat-icon>compare_arrows</mat-icon>
            <span>Comparar con Actual</span>
          </button>
          <button
            mat-menu-item
            (click)="onRestoreVersion(version)"
            [disabled]="isLatestVersion(version)">
            <mat-icon>restore</mat-icon>
            <span>Restaurar</span>
          </button>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            (click)="onDeleteVersion(version)"
            class="delete-action"
            [disabled]="versiones.length <= 1">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>
      </div>

      <div class="version-description" *ngIf="version.descripcion">
        <span>{{ getVersionDescription(version) }}</span>
      </div>

      <div class="version-stats">
        <span class="version-size">
          {{ (version.cuerpoHTML?.length || 0) | number }} caracteres
        </span>
      </div>
    </div>

    <!-- EMPTY STATE -->
    <div *ngIf="versiones.length === 0" class="empty-state">
      <mat-icon class="empty-icon">history</mat-icon>
      <p>No hay versiones guardadas</p>
      <button mat-stroked-button (click)="onCreateVersion()">
        <mat-icon>add</mat-icon>
        Crear Primera Versión
      </button>
    </div>
  </div>

  <!-- HELP TEXT -->
  <div class="help-text" *ngIf="currentEscritoId">
    <mat-icon>info</mat-icon>
    <span>Click para seleccionar, menú para más opciones</span>
  </div>
</div>
